// extracted by mini-css-extract-plugin
export var linkText = "_ow-0";